import * as React from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Box } from "@mui/material";

const columns = [
  { field: "company", headerName: "Company", width: 130 },
  { field: "start_date", headerName: "Start Date", type: "date", width: 130 },
  { field: "end_date", headerName: "End Date", type: "date", width: 130 },
  { field: "user_id", headerName: "User", width: 100 },
  { field: "id", headerName: "ID", width: 400 },
  { field: "start_time", headerName: "Start Time", width: 400 },
];

const rows = [
  { id: 1, lastName: "Snow", firstName: "Jon", age: 35 },
  { id: 2, lastName: "Lannister", firstName: "Cersei", age: 42 },
  { id: 3, lastName: "Lannister", firstName: "Jaime", age: 45 },
  { id: 4, lastName: "Stark", firstName: "Arya", age: 16 },
  { id: 5, lastName: "Targaryen", firstName: "Daenerys", age: null },
  { id: 6, lastName: "Melisandre", firstName: null, age: 150 },
  { id: 7, lastName: "Clifford", firstName: "Ferrara", age: 44 },
  { id: 8, lastName: "Frances", firstName: "Rossini", age: 36 },
  { id: 9, lastName: "Roxie", firstName: "Harvey", age: 65 },
];

/**
 * DataTable component.
 *
 * This component renders a data grid table with specified rows and columns.
 *
 * @param {Object} props - The properties passed to the component.
 * @param {string|Object} props.height - Height of the data grid container (an sx breakpoint object also works).
 * @param {Array<Object>} props.dataRows - Array of objects representing the rows in the data grid.
 * @param {Array<Object>} props.columns - Array of objects representing the columns in the data grid.
 * @param {Function} [props.onRowClick] - Called with DataGrid row params when a row is clicked.
 * @param {Array<string|number>} [props.rowSelectionModel] - Controlled selected row ids.
 * @param {Function} [props.onRowSelectionModelChange] - Called when selection changes.
 *
 * @returns {JSX.Element} - The JSX element for the data table.
 */
function DataTable({
  height,
  dataRows,
  columns,
  onRowClick,
  rowSelectionModel,
  onRowSelectionModelChange,
}) {
  return (
    <Box sx={{ height: height, width: "100%" }}>
      <DataGrid
        rows={dataRows}
        columns={columns}
        density="compact"
        onRowClick={onRowClick}
        rowSelectionModel={rowSelectionModel}
        onRowSelectionModelChange={onRowSelectionModelChange}
        sx={onRowClick ? { "& .MuiDataGrid-row": { cursor: "pointer" } } : undefined}
      />
    </Box>
  );
}

export default DataTable;